

import { trackFB, trackGA, trackGTM, trackTT, isMb, getLocalStorage,getCampaignName, setLocalStorage } from '@efe-activity-fe-util/core'
import { ALL_GP_SELECTOR, ALL_IOS_SELECTOR, PANGLE_POPUP, PANGLE_GP_BUTTONS, PANGLE_IOS_BUTTONS, IGNORE_TRIGGER_PANGLE_BUTTONS, PANGLE_BUTTONS } from '../constants/selector'
import { STORAGE_KEY } from '../constants/trackUniqKeys'
import { usePopup } from '../hooks/usePopup'
import { useBackstage } from './backstage'
import { MB_STORE_CONFIG, PC_STORE_CONFIG } from '../libs/gaConfig'
import { omit } from '../utils/object'

const { getActivityConfig } = useBackstage()

const { openPopup, closePopupAll } = usePopup()

const iosSecondSendTo = 'AW-18322019198/n0icCKzv4NAcEP6mz6BE'
const gpSecondSendTo = 'AW-18322019198/my81CJ_94NAcEP6mz6BE'

let _openIosPangle = false
let _openAndPangle = false

function gpStoreTrack(trackingGtm = true) {
    
    if (trackingGtm) {
        trackGTM({
            once: true,
            storageKey: STORAGE_KEY.GTM_GP,
            data: {
                send_to: 'AW-18322019198/ISUSCMLdxdAcEP6mz6BE',
                value: 1.0,
                currency: 'USD',
            },
        })
    }

    

    
    if (!getLocalStorage(STORAGE_KEY.X_GP)) {
        twq?.('event', 'tw-re0gk-re0jd', {
            conversion_id: null,
            email_address: null,
            phone_number: null
        })
        setLocalStorage(STORAGE_KEY.X_GP, 1)
    }
    
}

function iosStoreTrack(trackingGtm = true) {
    
    if (trackingGtm) {
        trackGTM({
            once: true,
            storageKey: STORAGE_KEY.GTM_IOS,
            data: {
                send_to: 'AW-18322019198/K9gACLrE4NAcEP6mz6BE',
                value: 1.0,
                currency: 'USD',
            },
        })
    }
    

    
    if (!getLocalStorage(STORAGE_KEY.X_IOS)) {
        twq?.('event', 'tw-re0gk-re0h7', {
            conversion_id: null,
            email_address: null,
            phone_number: null
        })
        setLocalStorage(STORAGE_KEY.X_IOS, 1)
    }
    


    zafIosStoreTrack()
    seedappIosStoreTrack()
}

function allStoreTrack(ttType: 'ClickButton' | 'Subscribe' = 'ClickButton') {
    
    trackFB({
        once: true,
        storageKey: STORAGE_KEY.FB_SHOP,
        event: 'Subscribe',
        data: { currency: 'USD', value: 0.0 },
    })
    

    
    trackTT({
        once: true,
        storageKey: STORAGE_KEY.TT_SHOP,
        event: ttType,
    })
    
}


function zafIosStoreTrack() {
    
    if (getLocalStorage(STORAGE_KEY.ZAF_IOS)) {
        return
    }

    $('body').append(`<script> var cx_postback_option = "non_load" </script><script> var cx_params_7450 = { "oid": "計測用文字列", "ma_campaign_id": 7450 } </script><script src="https://s3.ap-northeast-1.amazonaws.com/x-storage.cir.io/weblink/multi_postback.js" id="cxPostback_7450"></script>`)
    setLocalStorage(STORAGE_KEY.ZAF_IOS, '1')
    
}

function seedappIosStoreTrack() {
    
    if (getLocalStorage(STORAGE_KEY.SEEDAPP_IOS)) {
        return
    }

    $('body').append(`
            <span id="a8sales"></span>
            <script src="//statics.a8.net/a8sales/a8sales.js"></script>
            <script>
            a8sales({
                pid: "s00000020278145",
                order_number: "1",
                currency: "JPY",
                items: [{
                    code: "1",
                    price: 1,
                    quantity: 1
                }],
                total_price: 1
            });
            </script>
            `)
    setLocalStorage(STORAGE_KEY.SEEDAPP_IOS, '1')
    
}

function openPanglePopup() {
    closePopupAll()
    openPopup(PANGLE_POPUP)
}

export async function storeTrack() {
    try {
        const activityConfig = await getActivityConfig()
        const { openIosPangle = false, openAndPangle = false } = (activityConfig?.activityMsgConfig
            ?.activityMsg?.context ?? {}) as unknown as Record<string, any>
        _openIosPangle = openIosPangle
        _openAndPangle = openAndPangle
    } finally {
        const isAndPangle = _openAndPangle && isAndPangleChannel()
        const isIosPangle = _openIosPangle && isIosPangleChannel()

        if (isAndPangle) {
            $(PANGLE_GP_BUTTONS).on('click', () => {
                closePopupAll()
            })
        }

        if (isIosPangle) {
            $(PANGLE_IOS_BUTTONS).on('click', () => {
                closePopupAll()
            })
        }

        listenStoreTrack(isAndPangle, isIosPangle)
    }
    
}

function listenStoreTrack(isAndPangle: boolean, isIosPangle: boolean) {
    console.log('isAndPangle', isAndPangle, 'isIosPangle', isIosPangle)
    const storeConfig = isMb() ? MB_STORE_CONFIG : PC_STORE_CONFIG

    if (!isAndPangle && !isIosPangle) {
        storeConfig.forEach(({ selector, parentDom, ...options }) => {
            if (parentDom) {
                $(parentDom).on('click', selector, () => trackGA(options))
            } else {
                $(selector).on('click', () => trackGA(options))
            }
        })
    }

    $(document).on('click', ALL_GP_SELECTOR, (e) => {
        if ($(e.currentTarget).closest(PANGLE_BUTTONS).length > 0) {
            return
        }

        const $target = $(e.target)
        const ignored =
            $target.closest(IGNORE_TRIGGER_PANGLE_BUTTONS).length > 0

        const triggedGaConfig =
            storeConfig.find(
                ({ selector }) => $target.closest(selector).length > 0
            ) ?? null

        if (ignored && triggedGaConfig) {
             trackGA(
                omit(triggedGaConfig, ['parentDom', 'selector']) as Parameters<
                    typeof trackGA
                >[0]
            )
        }

        if (!ignored && isAndPangle) {
            $(PANGLE_BUTTONS).data('gaConfig', triggedGaConfig)
            e.preventDefault()
            openPanglePopup()
        } else {
            gpStoreTrack()
            allStoreTrack()
        }
    })

    $(document).on('click', ALL_IOS_SELECTOR, (e) => {
        if ($(e.currentTarget).closest(PANGLE_BUTTONS).length > 0) {
            return
        }

        const $target = $(e.target)
        const ignored =
            $target.closest(IGNORE_TRIGGER_PANGLE_BUTTONS).length > 0

         const triggedGaConfig =
                storeConfig.find(
                    ({ selector }) => $target.closest(selector).length > 0
                ) ?? null
            $(PANGLE_BUTTONS).data('gaConfig', triggedGaConfig)

         if (ignored && triggedGaConfig) {
             trackGA(
                omit(triggedGaConfig, ['parentDom', 'selector']) as Parameters<
                    typeof trackGA
                >[0]
            )
        }

        if (!ignored && isIosPangle) {
           
            e.preventDefault()
            openPanglePopup()
        } else {
            iosStoreTrack()
            allStoreTrack()
        }
    })

    $(PANGLE_BUTTONS).on('click', (e) => {
        console.log('PANGLE_BUTTONS clicked')
        const { type = 'gp', gaConfig = null } = $(e.currentTarget).data()
        const storeTrackGTM = type === 'gp' ? gpStoreTrack : iosStoreTrack
        const storeTrackGTMEvent = !(type === 'gp' ? gpSecondSendTo : iosSecondSendTo)


        storeTrackGTM(storeTrackGTMEvent)
        allStoreTrack('Subscribe')

        if (type === 'ios' && iosSecondSendTo) {
            trackGTM({
                once: true,
                storageKey: STORAGE_KEY.GTM_SECOND_IOS,
                data: {
                    send_to: iosSecondSendTo,
                    value: 1.0,
                    currency: 'USD',
                },
            })
        }

        if (type === 'gp' && gpSecondSendTo) {
            trackGTM({
                once: true,
                storageKey: STORAGE_KEY.GTM_SECOND_GP,
                data: {
                    send_to: gpSecondSendTo,
                    value: 1.0,
                    currency: 'USD',
                },
            })
        }

        if (gaConfig) {
            trackGA(
                omit(gaConfig, ['parentDom', 'selector']) as Parameters<
                    typeof trackGA
                >[0]
            )
        }
    })
}

export function isOpenIosPangle() {
    return _openIosPangle && isIosPangleChannel()
}

export function isOpenAndPangle() {
    return _openAndPangle && isAndPangleChannel()
}

function getCurrentDevicePangleRules(rules: {
    pc?: string[]
    mb?: string[]
}) {
    return (isMb() ? rules.mb : rules.pc) ?? []
}

export function isIosPangleChannel() {
    const params = getCampaignName()
    const rules = getCurrentDevicePangleRules({"pc":[],"mb":["^(?:[^_]*_){4}Smart_[^_]*_Subscribe_ios-pangle(?:_|$).*","^(?:[^_]*_){4}dg_tanchuang(?:_|$).*"]})
    return rules.some((r) => new RegExp(r).test(params))
}

export function isAndPangleChannel() {
    const params = getCampaignName()
    const rules = getCurrentDevicePangleRules({"pc":[],"mb":["^(?:[^_]*_){4}Smart_[^_]*_Subscribe_and-pangle(?:_|$).*","^(?:[^_]*_){4}dg_tanchuang(?:_|$).*"]})
    return rules.some((r) => new RegExp(r).test(params))
}
